/* eslint-disable react/require-default-props */
import React from 'react';
import { Text } from '@ui/atoms/Text';
/**
 * PopupTitle
 * Group heading label for a popup section.
 * Use once per section, before section items.
 * @version 1.0.0
 * @since 2026-03-27
 */
export function PopupTitle({ children }) {
    return (React.createElement(Text, { as: "h4", variant: "xx-small", className: "qmb-ui-popup__title" }, children));
}
PopupTitle.displayName = 'PopupTitle';
